(function () {
	"use strict";

	function StarField()
	{
		this.DisplayObject_constructor();
		this.mouseEnabled = false;
		this.stars = [];
		this.createStarField();
	}

	var p = createjs.extend(StarField, cjs.DisplayObject);

	p.createStarField = function () {
		var fl = 500;
		var w = cm.app.display.width / 2;
		var h = cm.app.display.height / 2;

		var depth = 5000;
		var scale = fl / (fl + depth);
		var amount = cm.Device.iPad2 ? 100 : 200; // lame ipad 2

		for (var i = 0; i < amount; i++) {
			var star = {};
			star.posX = Math.range(-w, w) * scale;
			star.posY = Math.range(-h, h) * scale;
			star.posZ = depth;
			star.x = star.posX;
			star.y = star.posY;
			star.z = star.posZ;
			star.alpha = 0;
			star.scale = scale;
			star.randomScale = Math.range(1, 5);
			star.randomAlpha = 0.35 + Math.random();

			var d = Math.random() * 35 + 5;
			var a = Math.random() * Math.PI * 2;
			star.vx = Math.cos(a) * d;
			star.vy = Math.sin(a) * d;
			star.vz = (Math.random() * 20 + 10) * (0.5 + 0.01) * 4;
			star._x = star.posX;
			star._y = star.posY;

			this.stars.push(star);
		}
	};

	p.draw = function(ctx, ignoreCache) {
		// var l = this.starField.numChildren;
		if(cm.main.pause){return;}
		ctx.save();

		var l = this.stars.length;
		var fl = 500;
		var w = cm.app.display.width * 0.5;
		var h = cm.app.display.height * 0.5;

		for (var i = l - 1; i >= 0; i--) {
			var star = this.stars[i];
			var scale = fl / (fl + star.z);
			star._x += star.vx;
			star._y += star.vy;
			star.z -= star.vz * cm.main.speed * 0.4;
			star.x = star._x * scale;
			star.y = star._y * scale;
			star.scaleX = scale;
			star.scaleY = scale;

			if (star.alpha > 0) {
				ctx.beginPath();
				ctx.fillStyle = '#fff';
				ctx.globalAlpha = star.alpha;
				ctx.arc(star.x, star.y, 10 * star.scaleX, 0, Math.PI * 2);
				ctx.fill();
			}

			var ax = 0 - star.x;
			var ay = 0 - star.y;
			var theta = Math.atan2(ay, ax);
			theta *= 180 / Math.PI;
			if (theta < 0) {
				theta = 360 + theta;
			}

			star.rotation = theta;
			if(star.z < 4000){
				if(star.alpha < star.randomAlpha) {
					star.alpha += 0.01;
				}
			}

			if (star.z < 0) {
				star.z = 5000;
				star.posZ = star.z;
				scale = fl / (fl + star.z);
				star.scaleX = star.scaleY = scale;
				star.randomAlpha = 0.35 + Math.random();
				star.alpha = 0;
				star.posX = Math.range(-w, w) * scale;
				star.posY = Math.range(-h, h) * scale;
				star.x = star.posX;
				star.y = star.posY;

				var d = Math.random() * 35 + 5;
				var a = Math.random() * Math.PI * 2;

				star.vx = Math.cos(a) * d;
				star.vy = Math.sin(a) * d;
				star._x = star.posX;
				star._y = star.posY;
				star.vz = (Math.random() * 20 + 10) * (0.5 + 0.01) * 4;
			}
		}

		ctx.restore();
	};

	cm.StarField = cjs.promote(StarField, "DisplayObject");
})();